import { render, staticRenderFns } from "./Org_generate.vue?vue&type=template&id=0a8e75e8"
import script from "./Org_generate.vue?vue&type=script&lang=js"
export * from "./Org_generate.vue?vue&type=script&lang=js"
import style0 from "./Org_generate.vue?vue&type=style&index=0&id=0a8e75e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports